import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { attributeMultiple as AttributeMultiple } from 'theme/icon';
import { Tooltip } from 'antd';
import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';
import _ from 'lodash';
import { declOfNum } from 'utils/other';
import styles from './styles.scss';

const MultipleChoice = props => {
  const [value, setValue] = useState(props.value);
  const [isChanged, setIsChanged] = useState(props.meta.dirty);
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);
  // test
  const isMultipleChanged = () => {
    let changed = true;
    if (props.parentId && props.multipleChoiceId) {
      changed = !_.isEqual(
        (props.meta.initial.value || {})[props.multipleChoiceId],
        (props.value || {})[props.multipleChoiceId],
      );
    }

    return changed;
  };
  useEffect(() => {
    if (props.meta.dirty && isMultipleChanged) {
      setIsChanged(true);
    }
  }, [props.meta.dirty]);
  const { isEditable, delay } = props;
  const isShowArrow = isEditable;
  return (
    <React.Fragment>
      <div className={styles.row}>
        <div className={styles.header}>
          <div className={styles.icon}>
            <AttributeMultiple alt="" />
          </div>
          <div className={styles.caption}>
            <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
              <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
            </Tooltip>
          </div>
        </div>
        <div className={styles.body}>
          {(value || []).length > 0 && (
            <span>{`Выбрано ${value.length} ${declOfNum(['значение', 'значения', 'значений'], value.length)}`}</span>
          )}
        </div>
      </div>
      <VelocityTransitionGroup
        enter={{
          animation: {
            borderTopColor: [isChanged ? '#FFA037' : '#1B9CFB', '#FFFFFF'],
          },
          duration: 100,
          delay,
        }}
        leave={{
          animation: {
            borderTopColor: ['#FFFFFF', isChanged ? '#FFA037' : '#1B9CFB'],
          },
          duration: 300,
          complete: () => {
            if (!props.meta.dirty) {
              setIsChanged(false);
            }
          },
        }}
      >
        {isShowArrow && (
          <VelocityComponent
            runOnMount
            animation={{
              borderTopColor: isChanged ? '#FFA037' : '#1B9CFB',
            }}
            duration={100}
            delay={delay}
          >
            <span className={styles.arrowTop} />
          </VelocityComponent>
        )}
      </VelocityTransitionGroup>
      <VelocityTransitionGroup
        enter={{
          animation: {
            borderTopColor: [isChanged ? '#FFFBEF' : '#E5EFFF', '#FFFFFF'],
          },
          duration: 100,
          delay,
        }}
        leave={{
          animation: {
            borderTopColor: ['#FFFFFF', isChanged ? '#FFFBEF' : '#E5EFFF'],
          },
          duration: 300,
        }}
      >
        {isShowArrow && (
          <VelocityComponent
            animation={{
              borderTopColor: isChanged ? '#FFFBEF' : '#E5EFFF',
            }}
            duration={100}
            delay={delay}
          >
            <span className={styles.arrowBottom} />
          </VelocityComponent>
        )}
      </VelocityTransitionGroup>
    </React.Fragment>
  );
};

MultipleChoice.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.any),
  delay: PropTypes.number.isRequired,
  isEditable: PropTypes.bool.isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  multipleChoiceId: PropTypes.number,
  parentId: PropTypes.number,
};

MultipleChoice.defaultProps = {
  value: null,
  multipleChoiceId: null,
  parentId: null,
};

export default MultipleChoice;
